import React from 'react'
import { M_Table } from 'src/M_Components'

const ShipmentTerms = ({ roles }) => {
  return (
    <M_Table entityName={'shippingTerms'} rolePermissions={roles} />
  )
}

export default ShipmentTerms